import {
  menu,
  popMenu,
  type PopupTarget,
} from '@blocksuite/affine-components/context-menu';

import type { DataSource } from '../../core/data-source/base.js';
import type { GroupTrait } from '../../core/group-by/trait.js';
import { dataViewI18nT } from '../../core/i18n.js';

/**
 * Human-readable label for a property type id, e.g. `multi-select`
 * → `Multi-select`. Shown next to the property name so the user
 * knows which column the new group lands in.
 */
function propertyTypeLabel(type: string | undefined): string {
  if (!type) return '';
  return type.charAt(0).toUpperCase() + type.slice(1);
}

/**
 * Shared "create new group" input popup for the kanban add-group
 * buttons (L1 columns and L2 sub groups, PC and mobile). Titles the
 * menu with the grouping property's name and type so the naked input
 * has context — the entered text becomes a new option on exactly
 * that property.
 */
export function popAddGroupInput(
  target: PopupTarget,
  groupTrait: GroupTrait,
  dataSource: DataSource
): void {
  const addGroup = groupTrait.addGroup;
  const property = groupTrait.property$.value;
  if (!addGroup || !property) {
    return;
  }
  const typeLabel = propertyTypeLabel(property.type$.value);
  const propertyName = property.name$.value;
  popMenu(target, {
    options: {
      title: {
        text: typeLabel
          ? dataViewI18nT('kanban.newGroupTitleWithType', {
              property: propertyName,
              type: typeLabel,
            })
          : dataViewI18nT('kanban.newGroupTitle', { property: propertyName }),
      },
      items: [
        menu.input({
          placeholder: dataViewI18nT('kanban.groupNamePlaceholder'),
          onComplete: text => {
            property.dataUpdate(() =>
              addGroup({
                text,
                oldData: property.data$.value,
                dataSource,
              })
            );
          },
        }),
      ],
    },
  });
}
